export const environment = {
    production: true,
    deploy_environment: 'default',
    test_environment: undefined,
};
